var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Featured icon",
    filter: "url(#filter0_d_2232_70964)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#E8EEFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/message-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.3307 34.8337H20.6641C15.3307 34.8337 12.6641 33.5003 12.6641 26.8337V20.167C12.6641 14.8337 15.3307 12.167 20.6641 12.167H31.3307C36.6641 12.167 39.3307 14.8337 39.3307 20.167V26.8337C39.3307 32.167 36.6641 34.8337 31.3307 34.8337H30.6641C30.2507 34.8337 29.8507 35.0337 29.5974 35.367L27.5974 38.0337C26.7174 39.207 25.2774 39.207 24.3974 38.0337L22.3974 35.367C22.1841 35.0737 21.6907 34.8337 21.3307 34.8337Z",
    stroke: "#2948A7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.3359 20.167H32.6693",
    stroke: "#2948A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.3359 26.833H27.3359",
    stroke: "#2948A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2232_70964",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2232_70964"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2232_70964",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquare);
export default __webpack_public_path__ + "static/media/messageSquare.24a23597576495dfd8c6432427dccf35.svg";
export { ForwardRef as ReactComponent };